module.exports = __webpack_public_path__ + "130c940875ffd777196159c49a348a02.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/mer-tail-coral.png
// module id = 1310
// module chunks = 0